import { Star } from "lucide-react";
import { useGoogleReviews } from "@/context/GoogleReviewsContext";

const GOOGLE_REVIEW_URL = "https://g.page/r/CdeH-owIuo6vEAI/review";
// Show the badge as soon as we have ONE real Google review so a fresh
// boutique can start earning trust immediately.
const MIN_TOTAL = 1;

/**
 * GoogleRatingBadge — compact "★ 4.9 · 42 Google reviews" chip.
 * Two variants:
 *   variant="nav"    → tiny header pill (hidden on mobile to save space)
 *   variant="footer" → footer line, slightly more prominent
 * Renders nothing until we have ≥3 reviews.
 */
export function GoogleRatingBadge({ variant = "nav" }) {
  const { data } = useGoogleReviews();
  const rating = data?.rating;
  const total = data?.total || 0;
  if (!rating || total < MIN_TOTAL) return null;
  const ratingStr = Number(rating).toFixed(1);

  if (variant === "footer") {
    return (
      <a
        href={GOOGLE_REVIEW_URL}
        target="_blank"
        rel="noreferrer"
        data-testid="footer-google-rating-badge"
        className="group inline-flex items-center gap-2 text-espresso hover:text-gold-hover transition-colors"
      >
        <Star size={14} strokeWidth={1.5} className="fill-gold text-gold" />
        <span className="font-serif text-sm">
          <span className="text-espresso">{ratingStr}</span>
          <span className="text-espresso-light"> · {total} Google review{total === 1 ? "" : "s"}</span>
        </span>
      </a>
    );
  }

  return (
    <a
      href={GOOGLE_REVIEW_URL}
      target="_blank"
      rel="noreferrer"
      data-testid="nav-google-rating-badge"
      title={`${ratingStr} on Google · ${total} reviews`}
      className="hidden lg:inline-flex items-center gap-1.5 px-2.5 py-1 border border-line hover:border-gold rounded-full text-espresso hover:text-gold-hover transition-colors"
    >
      <Star size={12} strokeWidth={1.5} className="fill-gold text-gold" />
      <span className="text-xs font-medium tracking-wide">
        {ratingStr}
        <span className="text-espresso-light font-normal ml-1">· {total}</span>
      </span>
    </a>
  );
}
